import { Badge, Button, Flex, Skeleton, Text } from '@radix-ui/themes';
import React from 'react';

export interface QuickFilterItemProps<TValue> {
    value: TValue;
    Icon: React.ElementType;
    label: React.ReactNode;
    count?: number;
    isLoading?: boolean;
    isActive?: boolean;
    onClick: (val: TValue) => void;
}

export const QuickFilterItem = <TValue,>({
    value,
    Icon,
    label,
    count,
    isLoading = false,
    isActive = false,
    onClick,
}: QuickFilterItemProps<TValue>) => (
    <Button
        radius='none'
        onClick={() => onClick(value)}
        style={{
            backgroundColor: isActive ? 'var(--gray-a3)' : 'transparent',
            transition: 'background-color 0.2s ease',
            cursor: 'pointer',
        }}
        asChild
    >
        <Flex px='2' py='1' justify='between'>
            <Flex align='center' gap='2'>
                <Icon
                    width='16'
                    height='16'
                    style={{
                        color: isActive ? 'var(--gray-12)' : 'var(--gray-9)',
                    }}
                />
                <Text
                    size='2'
                    weight={isActive ? 'bold' : 'medium'}
                    style={{
                        color: isActive ? 'var(--gray-12)' : 'var(--gray-9)',
                    }}
                >
                    {label}
                </Text>
            </Flex>

            {count !== undefined && (
                <Skeleton loading={isLoading}>
                    <Badge
                        size='1'
                        variant={isActive ? 'solid' : 'soft'}
                        color='gray'
                        radius='full'
                    >
                        {new Intl.NumberFormat().format(count)}
                    </Badge>
                </Skeleton>
            )}
        </Flex>
    </Button>
);
